/**
 * Return the boolean value of whether the email is valid or not.
 * @param email
 * @returns
 */
export const validateEmail = (email: string): boolean => {
  const pattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return pattern.test(email);
};
